import { Suspense } from "react"
import { Outlet } from "react-router-dom"

import { LogoImage } from "@/atoms"
import { useLogger } from "@/hooks/useLogger"
import { useUser } from "@/hooks/useUser"
import { Loader } from "@/molecules/Loader"
import { ErrorBoundary } from "@/organisms/ErrorBoundary"

import styles from "./MinimalLayoutTemplate.module.scss"

// No navigation: for pages opened from outside the app.
export const MinimalLayoutTemplate = () => {
  const { logger } = useLogger()
  const { user } = useUser()

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <LogoImage height={32} />
      </header>
      <main className={styles.main}>
        <ErrorBoundary user={user} logger={logger}>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
    </div>
  )
}
